

















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
@Component
export default class App extends Vue {
    public name: string = ''
    created() {
        this.updateName(this.$route.name)
    }

    updateName(name: string | undefined) {
        switch (name) {
            case 'Generate':
                this.name = ''
                break
            case 'Donate':
                this.name = this.$route.query.name as string || 'Author'
                break
            default:
                break
        }
    }

    @Watch('$route')
    routed(to: Route, from: Route) {
        this.updateName(to.name)
    }
}
